import { render, staticRenderFns } from "./Geometry.vue?vue&type=template&id=2f25ca98&scoped=true"
import script from "./Geometry.vue?vue&type=script&lang=js"
export * from "./Geometry.vue?vue&type=script&lang=js"
import style0 from "./Geometry.vue?vue&type=style&index=0&id=2f25ca98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25ca98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f25ca98')) {
      api.createRecord('2f25ca98', component.options)
    } else {
      api.reload('2f25ca98', component.options)
    }
    module.hot.accept("./Geometry.vue?vue&type=template&id=2f25ca98&scoped=true", function () {
      api.rerender('2f25ca98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sysParam/MapSetting/Geometry.vue"
export default component.exports